import React, { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { IoIosArrowDropdownCircle } from 'react-icons/io';

import { warningLogManager } from 'redux/action/warningLog';
import { customAxiosPostFunction } from 'utils/axiosFunction';

import useCancellationToken from 'utils/customHook/useCancellationToken';
import SideEventLog from './SideEventLog';
import { SideLogContainer, SideTitle } from './SideLogContainer.css';

const SideEventLogs = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const cancellationToken = useCancellationToken();
  const warningLogs = useSelector((store) => store.warningLogs); // 경고, 교정기한임박 로그 데이터
  const authIdx = useSelector((store) => store.loginManager.status.authIdx); // 장치 데이터
  const [systemLogs, setSystemLogs] = useState([]);

  useEffect(() => {
    if (cancellationToken.isCancelled) {
      return;
    }

    if (warningLogs.warningStatus === 'SUCCESS') {
      setSystemLogs(warningLogs.warningLog.slice(0, 30));
    }
  }, [warningLogs, cancellationToken]);

  useEffect(() => () => cancellationToken.cancel(), [cancellationToken]);

  const handleClickEventLogSubTitle = useCallback(async (type) => {
    await customAxiosPostFunction(history, '/api/log/multiConfirmWarning', type);

    dispatch(warningLogManager(authIdx));
  });

  return (
    <>
      <SideTitle>이벤트 로그</SideTitle>
      <SideLogContainer>
        <div className="title">
          <div>
            O<sub>2</sub>
          </div>
          <div
            onClick={() => {
              handleClickEventLogSubTitle(['0']);
            }}
          >
            <IoIosArrowDropdownCircle />
          </div>
        </div>
        <div className="content">
          {systemLogs &&
            (systemLogs.filter((x) => x.moduleScn === '0').length > 0 ? (
              systemLogs
                .filter((x) => x.moduleScn === '0')
                .map((data) => {
                  return <SideEventLog key={`${data.warningLogIdx}`} {...data} authIdx={authIdx} />;
                })
            ) : (
              <div className="none_data">특이사항 없음</div>
            ))}
        </div>
      </SideLogContainer>
    </>
  );
};

export default SideEventLogs;
